import { API_MARKETPRICE_DB } from '../../api/api';
import Axios from 'axios';

export const getMarketpriceDb = (value) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch({
        type: 'GET_MARKETPRICE_START',
      });
      const response = await Axios.post(API_MARKETPRICE_DB.get, value, config);
      const { data, message } = response.data;

      if (data.data) {
        dispatch({
          type: 'GET_MARKETPRICE_SUCCESS',
          payload: {
            data: data.data,
            message: message,
            total_data: data.total_data,
          },
        });
      }
    } catch (err) {
      if (err.response) {
        dispatch({
          type: 'GET_MARKETPRICE_FAILURE',
          payload: { error_code: err.response.status, message: err.response.statusText },
        });
      } else {
        dispatch({
          type: 'GET_MARKETPRICE_FAILURE',
          payload: { error_code: 'Unknown', message: err },
        });
      }
    }
  };
};
